<template>
  <div>
    <Table
      :sum-text="sumText"
      :columns="columns"
      :border="border"
      :data="data"
      size="small"
      :show-summary="showSummary"
      :summary-method="summaryMethod"
      @on-selection-change="onSelectChange"
      @on-select="onSelect"
      on-current-change="onCurrentChange"
      :ref="refs"
      :max-height="maxHeight"
      :height="height"
      :row-class-name="rowClassName"
      :span-method="handleSpan"
    >
      <slot></slot>
    </Table>
    <div
      class="pagination"
      v-if="total > 10 && showPage"
    >
      <Page
        :total="total"
        :current="safeCurrent"
        @on-change="changePage"
        :page-size="safePageSize"
        show-elevator
      ></Page>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    'columns': {},
    'data': {},
    'total': {},
    'current': { type: [Number, String], default: 1 },
    'showPage': {},
    'refs': {},
    'sum-text': {},
    'maxHeight': {},
    'height': {},
    'show-summary': {},
    'summary-method': {},
    'border': {},
    'row-class-name': {},
    'span-method': {},
    pageSize: { type: [Number, String], default: 10 }
  },
  computed: {
    safeCurrent () {
      const current = Number(this.current)
      return Number.isFinite(current) && current > 0 ? current : 1
    },
    safePageSize () {
      const pageSize = Number(this.pageSize)
      return Number.isFinite(pageSize) && pageSize > 0 ? pageSize : 10
    }
  },
  data () {
    return {}
  },
  methods: {
    changePage (index) {
      this.$emit('change',index)
    },
    onSelectChange (selection) {
      this.$emit('onSelectChange',selection)
      this.$emit('on-select-change',selection)
    },
    onSelect (selection,row) {
      this.$emit('onSelect',selection,row)
    },
    handleSpan ({row,column,rowIndex,columnIndex}) {
      if(this.spanMethod) {
        this.spanMethod({row,column,rowIndex,columnIndex})
      }
    }
  }
}
</script>
